/*
 * @author: liaosir
 */
import { APP_MODE } from 'ice';
const protocolStr = process.env.NODE_ENV === 'development' ? 'https:' : document.location.protocol;

const FORGET_PASSWORD_URLS = {
  dev: `${protocolStr}//usc-test.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws-test.i4px.com/user/login`,
  test: `${protocolStr}//usc-test.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws-test.i4px.com/user/login`,
  stage: `${protocolStr}//ucs.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws-stage.i4px.com/user/login`,
  prod: `${protocolStr}//ucs.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws.i4px.com/user/login`,
  eu: `${protocolStr}//ucs.eu.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws.eu.i4px.com/user/login`,
  us: `${protocolStr}//ucs.us.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws.us.i4px.com/user/login`,
  au: `${protocolStr}//ucs.au.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws.au.i4px.com/user/login`,
  asia: `${protocolStr}//ucs.asia.i4px.com/user/forgetpassword?redirectUrl=${protocolStr}//giws.asia.i4px.com/user/login`,
};

/**
 * @description 登录cas地址
 */
const FORGET_PASSWORD_URL = FORGET_PASSWORD_URLS[APP_MODE];

export { FORGET_PASSWORD_URL };
